/*! JointJS+ v4.2.2 (2026-01-22) - HTML5 Diagramming Framework

Copyright (c) 2025 client IO

This Source Code Form is subject to the terms of the JointJS+
License, v. 2.0. If a copy of the JointJS+ License was not
distributed with this file, You can obtain one at
https://www.jointjs.com/license or from the JointJS+ archive as was
distributed by client IO. See the LICENSE file.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { shapes, g, connectionPoints, util } from '@joint/plus';
var cache = new Map();
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultLabel = {
            attrs: {
                rect: {
                    fill: '#ffffff',
                    stroke: '#353535',
                    strokeWidth: 1,
                    width: 'calc(w + 10)',
                    height: 'calc(h + 10)',
                    x: 'calc(x - 5)',
                    y: 'calc(y - 5)'
                }
            }
        };
        _this.getDataWidthCached = function (d) {
            if (cache.has(d)) {
                return cache.get(d);
            }
            else {
                var bbox = (new g.Path(d)).bbox();
                cache.set(d, bbox ? bbox.width : 0);
                return cache.get(d);
            }
        };
        return _this;
    }
    Link.connectionPoint = function (line, view, magnet, _opt, type, linkView) {
        var link = linkView.model;
        var markerWidth = (link.get('type') === 'app.Link') ? link.getMarkerWidth(type) : 0;
        var opt = { offset: markerWidth, stroke: true };
        // connection point for UML shapes lies on the root group containing all the shapes components
        var modelType = view.model.get('type');
        // taking the border stroke-width into account
        if (modelType === 'standard.InscribedImage') {
            opt.selector = 'border';
        }
        return connectionPoints.boundary.call(this, line, view, magnet, opt, type, linkView);
    };
    Link.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'app.Link',
            router: {
                name: 'normal'
            },
            connector: {
                name: 'rounded'
            },
            labels: [],
            attrs: {
                line: {
                    stroke: '#3771B8',
                    strokeDasharray: '0',
                    strokeWidth: 2,
                    fill: 'none',
                    sourceMarker: {
                        type: 'path',
                        d: 'M 0 0 0 0',
                        stroke: 'none'
                    },
                    'targetMarker': {
                        'd': 'M 0 0 0 0'
                    }
                }
            }
        }, _super.prototype.defaults);
    };
    Link.prototype.getMarkerWidth = function (type) {
        var d = (type === 'source') ? this.attr('line/sourceMarker/d') : this.attr('line/targetMarker/d');
        return this.getDataWidth(d);
    };
    Link.prototype.getDataWidth = function (d) {
        return this.getDataWidthCached(d);
    };
    return Link;
}(shapes.standard.Link));
export { Link };
export var cellNamespace = __assign(__assign({}, shapes), { app: {
        Link: Link
    } });
